"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var luxon_1 = require("luxon");
var React = __importStar(require("react"));
var entry_nostyle_1 = __importDefault(require("react-calendar/dist/entry.nostyle"));
var arrowDown_icon_1 = require("../../../../svg/arrowDown.icon");
var core_components_1 = require("@securityproducts/core-components");
var customDateRange_styles_1 = require("./customDateRange.styles");
var dateAndTime_styles_1 = require("./dateAndTime.styles");
var dateAndTime_i18n_1 = require("./dateAndTime.i18n");
var archiveDateFormat = { month: "short", year: "numeric" };
var dateFormat = { month: "short", day: "2-digit", year: "numeric" };
var timeFormat = { hour: "2-digit", minute: "2-digit" };
function DateAndTime(props) {
    var _a = React.useState(false), showCalendar = _a[0], setShowCalendar = _a[1];
    var containerNode = React.useRef();
    var _b = React.useState(false), calendarHidden = _b[0], setCalendarHidden = _b[1];
    var globalOffset = props.value.toJSDate().getTimezoneOffset();
    var _c = React.useState(false), showTimeSelect = _c[0], setShowTimeSelect = _c[1];
    var timeSelectNode = React.useRef(null);
    var strings = core_components_1.useLocalisation(dateAndTime_i18n_1.dateAndTimeTranslations, props.language);
    var timeArray = Array.from(Array(25).keys());
    function handleClick(e) {
        setCalendarHidden(containerNode.current === undefined || containerNode.current === null);
        if (timeSelectNode.current && timeSelectNode.current.contains(e.target)) {
            return;
        }
        setShowTimeSelect(false);
        if (containerNode &&
            containerNode.current &&
            containerNode.current.contains(e.target)) {
            return;
        }
        else {
            setShowCalendar(false);
            props.showArchivedTooltip(false);
        }
    }
    React.useEffect(function () {
        document.addEventListener("mousedown", handleClick, false);
        return function () {
            document.removeEventListener("mousedown", handleClick, false);
        };
    }, []);
    function setDate(date) {
        var offset = date.getTimezoneOffset();
        var newDate = luxon_1.DateTime.fromJSDate(date)
            .setZone("utc")
            .minus({ minutes: offset });
        if (!props.archiveMode) {
            newDate = newDate.set({ hour: props.value.hour, minute: props.value.minute });
        }
        props.setDate(newDate);
        if (!props.archiveMode) {
            props.setReset(true);
        }
        setShowCalendar(false);
    }
    function setTime(hour) {
        if (hour !== undefined) {
            var newDate = props.value.set({
                hour: hour === 24 ? 23 : hour,
                minute: hour === 24 ? 59 : 0,
                second: 0,
                millisecond: 0,
            });
            if (newDate) {
                props.setDate(newDate);
            }
        }
    }
    function checkField(times) {
        if (props.id === "start") {
            times.pop();
        }
        else {
            times.shift();
        }
        return times;
    }
    function getTileClassName(calendarTileProps) {
        var hasCallSummaryDate = props.callSummaryDataFrom !== undefined && props.callSummaryDataFrom !== null;
        var hasArchivedDate = props.archiveDataFrom !== undefined && props.archiveDataFrom !== null;
        if (!hasCallSummaryDate && !hasArchivedDate) {
            return undefined;
        }
        if (hasCallSummaryDate && !hasArchivedDate) {
            return undefined;
        }
        if (hasArchivedDate && !hasCallSummaryDate) {
            return calendarTileProps.date >= minDate ? dateAndTime_styles_1.archivedDate : undefined;
        }
        if (hasCallSummaryDate && hasArchivedDate) {
            var archivedDataInterval = luxon_1.Interval.fromDateTimes(props.archiveDataFrom
                .set({
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            })
                .toJSDate(), props.callSummaryDataFrom.plus({ minutes: globalOffset }).toJSDate());
            return archivedDataInterval.contains(luxon_1.DateTime.fromJSDate(calendarTileProps.date))
                ? props.archiveMode
                    ? undefined
                    : dateAndTime_styles_1.archivedDate
                : undefined;
        }
        return undefined;
    }
    var maxDate = core_components_1.DateAndTimeStore.getInstance()
        .todayEnd.plus({ minutes: globalOffset })
        .toJSDate();
    var minDate = getMinDate(props.callSummaryDataFrom, props.archiveDataFrom, props.archiveMode);
    function onActiveDateChange(args) {
        showArchivedTooltipCheck(args.activeStartDate);
    }
    function showArchivedTooltipCheck(activeStartDate) {
        var hasCallSummaryDate = props.callSummaryDataFrom !== undefined;
        var hasArchivedDate = props.archiveDataFrom !== undefined;
        if (hasArchivedDate) {
            var startOfCurrentMonth = luxon_1.DateTime.fromJSDate(activeStartDate);
            var endOfCurrentMonth = startOfCurrentMonth.endOf("month");
            var currentMonthInterval = luxon_1.Interval.fromDateTimes(startOfCurrentMonth, endOfCurrentMonth);
            if (hasCallSummaryDate) {
                var archivedDataInterval = luxon_1.Interval.fromDateTimes(props.archiveDataFrom, props.callSummaryDataFrom);
                !props.archiveMode &&
                    props.showArchivedTooltip(archivedDataInterval.overlaps(currentMonthInterval));
            }
            else {
                props.showArchivedTooltip(true);
            }
        }
    }
    function onOpenCalendar() {
        if (calendarHidden) {
            setShowCalendar(true);
            showArchivedTooltipCheck(props.value.startOf("month").toJSDate());
        }
        else {
            setCalendarHidden(false);
        }
    }
    var timeInputClass;
    if (props.display === "HOURS") {
        timeInputClass = showTimeSelect ? dateAndTime_styles_1.timeInputActive : dateAndTime_styles_1.timeInput;
    }
    else {
        timeInputClass = dateAndTime_styles_1.disableTimeInput;
    }
    var rowClass = props.archiveMode ? null : customDateRange_styles_1.row;
    var language = props.language ? props.language : core_components_1.getBrowserLanguage();
    var locale = language === "en" ? "en-US" : language;
    function getLocaleTime(hour, minute) {
        if (hour === 0) {
            return strings.startDayOf;
        }
        if (hour === 12) {
            return strings.noon;
        }
        if (hour === 24 || (hour === 23 && minute === 59)) {
            return strings.endDayOf;
        }
        return core_components_1.customLocale(luxon_1.DateTime.utc().set({
            hour: hour,
            minute: minute ? minute : 0,
        }), language, timeFormat);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: props.id, className: rowClass },
            React.createElement("div", { id: "date", className: dateAndTime_styles_1.dateTime },
                React.createElement("label", { className: customDateRange_styles_1.label }, props.label),
                React.createElement("input", { id: props.id + "-date", readOnly: true, type: "text", value: core_components_1.customLocale(props.value, language, props.archiveMode ? archiveDateFormat : dateFormat), onClick: onOpenCalendar, className: dateAndTime_styles_1.dateInput + " " + (showCalendar &&
                        dateAndTime_styles_1.activeCalendar) + " chromatic-ignore" })),
            !props.archiveMode && (React.createElement("div", { id: "time", className: dateAndTime_styles_1.dateTime },
                React.createElement("label", { className: customDateRange_styles_1.label }, strings.time),
                React.createElement("div", { className: timeInputClass },
                    React.createElement("div", { ref: props.inputRef ? props.inputRef : undefined, id: props.id + "-time", "data-qa-enabled": props.display === "HOURS" ? true : false, className: dateAndTime_styles_1.options, onClick: function () {
                            setShowTimeSelect(!showTimeSelect);
                        } },
                        React.createElement("div", { className: dateAndTime_styles_1.wrap, ref: timeSelectNode, id: props.id + "-time-select", "data-showing": showTimeSelect }, getLocaleTime(props.value.hour, props.value.minute)),
                        React.createElement("div", { className: dateAndTime_styles_1.downArrow },
                            React.createElement(arrowDown_icon_1.ArrowDownIcon, { disabled: props.display !== "HOURS" })),
                        showTimeSelect ? (React.createElement("div", { id: props.id + "-time-options", className: dateAndTime_styles_1.modal, ref: timeSelectNode }, checkField(timeArray).map(function (value, i) { return (React.createElement("div", { "data-qa": props.id + "-time", key: i, className: dateAndTime_styles_1.titleModalButton, onClick: function () {
                                setTime(value);
                            } }, getLocaleTime(value))); }))) : (undefined))))),
            showCalendar && (React.createElement("div", { ref: containerNode },
                React.createElement(entry_nostyle_1.default, { locale: locale, onChange: setDate, onActiveDateChange: onActiveDateChange, onClickMonth: function (e) {
                        setDate(e);
                        setShowCalendar(false);
                    }, minDate: minDate, maxDate: maxDate, minDetail: props.archiveMode ? "year" : "month", tileClassName: getTileClassName, tileContent: TileBackground, value: props.value
                        .toUTC()
                        .plus({ minutes: globalOffset })
                        .toJSDate(), formatShortWeekday: formatShortWeekday, className: dateAndTime_styles_1.calendarCommon, formatMonth: function (locale, date) {
                        return core_components_1.customLocale(luxon_1.DateTime.fromJSDate(date).setZone("UTC", {
                            keepLocalTime: true,
                        }), locale, {
                            month: "short",
                        });
                    }, view: props.archiveMode ? "year" : "month" }))))));
}
exports.DateAndTime = DateAndTime;
function formatShortWeekday(locale, date) {
    var localeDateString = date.toLocaleString(locale, { weekday: "narrow" });
    return localeDateString.split(",")[0];
}
function TileBackground(props) {
    if (props.view === "month") {
        return (React.createElement("div", { className: "custom-tile" },
            React.createElement("div", null, props.date.getDate())));
    }
}
function getMinDate(callSummaryDataFrom, archiveDataFrom, archiveMode) {
    if (!callSummaryDataFrom && !archiveDataFrom) {
        return undefined;
    }
    if (callSummaryDataFrom && !archiveDataFrom) {
        return callSummaryDataFrom.toJSDate();
    }
    var monthStart = archiveMode
        ? archiveDataFrom.toJSDate()
        : archiveDataFrom
            .set({
            day: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        })
            .toJSDate();
    if (!callSummaryDataFrom && archiveDataFrom) {
        return monthStart;
    }
    return monthStart;
}
